import { useEffect, useState, type RefObject } from 'react';

const NO_OFFSETS: readonly number[] = [];
const FIRST_COLUMN_OFFSET = 0;
const MIN_COLUMNS_WITH_OFFSETS = 2;

export function usePinnedColumnOffsets(
  headerRowRef: RefObject<HTMLTableRowElement | null>,
  pinnedColumnCount: number,
): readonly number[] {
  const [offsets, setOffsets] = useState<readonly number[]>(NO_OFFSETS);

  useEffect(() => {
    const headerRow = headerRowRef.current;
    if (!headerRow || pinnedColumnCount < MIN_COLUMNS_WITH_OFFSETS) return;

    const leadingCells = Array.from(headerRow.cells).slice(0, pinnedColumnCount - 1);

    function measureOffsets() {
      const nextOffsets = [FIRST_COLUMN_OFFSET];
      let left = FIRST_COLUMN_OFFSET;
      for (const cell of leadingCells) {
        left += cell.getBoundingClientRect().width;
        nextOffsets.push(left);
      }
      setOffsets(nextOffsets);
    }

    const observer = new ResizeObserver(measureOffsets);
    for (const cell of leadingCells) {
      observer.observe(cell);
    }
    return () => observer.disconnect();
  }, [headerRowRef, pinnedColumnCount]);

  return offsets;
}
